// src/ResourcesSect// src/ResourcesSection.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from './axiosInstance';

const ResourcesSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true); // For mobile screens
      } else {
        setIsMobile(false); // For larger screens
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Run once to check initial window size

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        const response = await axiosInstance.get('/blog');
        setBlogPosts(response.data.slice(0, 4)); // Get the first 4 blog posts
      } catch (err) {
        console.error(err);
        setError('Failed to fetch blog posts');
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', // 1 column for mobile, 2 columns for larger screens
    gap: '16px', // Space between the cards
  };

  const cardStyle = {
    padding: '16px',
    borderRadius: '8px',
    backgroundColor: '#2d2d2d',
    color: 'white',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    transition: 'transform 0.3s, box-shadow 0.3s, border-color 0.3s',
    border: '2px solid #ff7c0a',
  };

  const imgStyle = {
    width: '100%',
    height: '200px', // Adjust for the image size
    objectFit: 'cover',
    borderRadius: '8px',
  };

  const titleStyle = {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginTop: '16px',
    color: '#ff7c0a',
  };

  const contentStyle = {
    fontSize: '1rem',
    marginTop: '8px',
    color: 'white',
  };

  const linkStyle = {
    marginTop: '16px',
    color: '#ff7c0a',
    fontWeight: 'bold',
    textDecoration: 'none',
  };

  const buttonStyle = {
    backgroundColor: '#ff7c0a',
    color: 'white',
    padding: '12px 24px',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: 'bold',
    textDecoration: 'none',
    transition: 'background-color 0.3s',
  };

  const buttonHoverStyle = {
    backgroundColor: '#e66b00',
  };

  return (
    <section
      style={{
        padding: '32px 16px',
        backgroundColor: 'black',
        color: 'white',
        textAlign: 'center',
        margin: '0 16px', // Add margin left and right
      }}
    >
      <h2 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '32px' }}>
        Resources
      </h2>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>{error}</p>
      ) : (
        <div style={gridStyle}>
          {blogPosts.map((post) => (
            <div key={post.id} style={cardStyle}>
              <img
                src={post.image}
                alt={post.title}
                style={imgStyle}
              />
              <h3 style={titleStyle}>{post.title}</h3>
              <p style={contentStyle}>{post.body.slice(0, 70)}...</p>
              <Link to={`/blog/${post.id}`} style={linkStyle}>
                Read More
              </Link>
            </div>
          ))}
        </div>
      )}
      <div style={{ marginTop: '32px', marginBottom: '32px' }}>
        <Link to="/blog" style={buttonStyle} onMouseOver={(e) => (e.target.style.backgroundColor = buttonHoverStyle.backgroundColor)} onMouseOut={(e) => (e.target.style.backgroundColor = buttonStyle.backgroundColor)}>
          View All Resources
        </Link>
      </div>
    </section>
  );
};

export default ResourcesSection;